import { LogoResult } from "./helpers";

export type BucketLogoSize = "large" | "medium";

export const getBucketBaseUrl = () =>
  (import.meta.env.VITE_LOGOS_BUCKET_URL as string | undefined)?.replace(
    /\/+$/,
    ""
  );

const PROBE_TIMEOUT_MS = 1500;

const probeBucketLogo = (
  id: string,
  size: BucketLogoSize
): Promise<string | null> =>
  new Promise<string | null>((resolve) => {
    const baseUrl = getBucketBaseUrl();
    if (!baseUrl) return resolve(null);

    const url = `${baseUrl}/${id}_url_${size}.png`;
    const img = new window.Image();
    const timeoutId = window.setTimeout(() => resolve(null), PROBE_TIMEOUT_MS);

    img.onload = () => {
      window.clearTimeout(timeoutId);
      resolve(url);
    };
    img.onerror = () => {
      window.clearTimeout(timeoutId);
      resolve(null);
    };

    img.src = url;
  });

export const fetchFromBucket = async (
  ids: string[],
  size: BucketLogoSize
): Promise<{ found: LogoResult[]; missing: string[] }> => {
  const results = await Promise.all(
    ids.map(async (id) => ({ id, url: await probeBucketLogo(id, size) }))
  );
  return {
    found: results.filter((r): r is LogoResult => Boolean(r.url)),
    missing: results.filter((r) => !r.url).map((r) => r.id),
  };
};
